snt-header {
    position: relative;
    display: block;
    width: 100%;
    height: auto;
    z-index: 99;
    &[fixed] {
        position: sticky;
        top: 0;
        left: 0;
        right: 0;
        height: 64px;
    }
    &[active] {
        @media(max-width: map-get($grid-breakpoints, lg) - 1px) {
            .brand-and-toggle, .actions-nav, snt-pane {
                display: none
            }
            header {
                padding: 0;
            }
        }
    }
    header {
        position: relative;
        margin: 0 auto;
        padding-top: 0;
    }
    .spacings {
        @include layout();
        overflow: visible;
        padding: 0;
    }
    snt-nav {
        &[slot=secondary-nav-mobile] {
            display: flex;
            @media(min-width: map-get($grid-breakpoints, lg)) {
                display: none;
            }
            snt-nav-item {
                margin: 0 0 0.625rem 0;
            }
        }
        &[slot=secondary-nav-desktop] {
            display: none;
            @media(min-width: map-get($grid-breakpoints, lg)) {
                display: flex;
            }
            snt-nav-item {
                margin: 0 0 0.625rem 0;
                @media(min-width: map-get($grid-breakpoints, md)) {
                    margin: 0 0 0 1.65rem;
                }
            }
        }
        snt-nav-item.top-nav {
            snt-link a {
                display: flex !important;
                justify-content: center !important;
                align-items: center !important;
            }
        }
    }
    snt-navbar-collapse {
        overflow: hidden;
        position: relative;
        justify-content: center;
        @media (min-width: map-get($grid-breakpoints, md)) {
            overflow: visible;
        }
    }
    snt-navbar-collapse {
        order: 1;
        @media (min-width: map-get($grid-breakpoints, md)) {
            order: initial;
        }
    }
    snt-navbar {
        display: flex;
        flex-flow: row nowrap;
        background-color: white;
        height: auto;
        flex-direction: column;
        @media (max-width: 1023px) {
            height: auto !important;
        }
    }
    snt-button {
        white-space: nowrap;
        button {
            padding: 3px !important;
            width: 25px;
            height: 25px;
            snt-icon {
                margin-right: 0 !important;
            }
        }
    }
    snt-link {
        a {
            background-image: none;
        }
        a:hover,
        a:focus {
            background-image: none;
            color: #323232;
            border-radius: 5px;
        }
        a button.expander {
            display: flex !important;
            position: relative !important;
            left: 1px !important;
            font-size: 8px !important;
        }
    }
    snt-skip-to-main {
        snt-link {
            @media (min-width: map-get($grid-breakpoints, lg)) {
                left: 20px;
            }
            @media (min-width: map-get($grid-breakpoints, xl)) {
                left: 135px;
            }
        }
        a {
            font-size: 12px;
            color: #323232;
            text-decoration: none;
            white-space: nowrap !important;
            &:focus {
                outline: none;
                border: 1px solid #147582;
                color: #323232;
                border-radius: 5px;
            }
        }
    }
    .header-container {
        width: 100%;
        max-width: 1440px;
        margin: auto;
        // background-color: white;
    }
    snt-navbar-brand {
        @media (min-width: map-get($grid-breakpoints, xs)) {
            margin-left: 30px;
        }
        @media (min-width: map-get($grid-breakpoints, lg)) {
            margin-left: 20px;
        }
        @media (min-width: map-get($grid-breakpoints, xl)) {
            margin-left: 135px;
        }
        snt-image img {
            @media (max-width: map-get($grid-breakpoints, sm)) {
                width: 80px;
                height: 16px;
            }
        }
    }
    #bar-items-container {
        @media (max-width: map-get($grid-breakpoints, sm)) {
            height: 49px;
        }
        height: 64px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    #switch-container {
        display: flex;
        flex-direction: row-reverse;
        width: 175px;
        @media (max-width: 1023px) {
            display: none;
        }
        @media (min-width: map-get($grid-breakpoints, lg)) {
            margin-right: 20px;
        }
        @media (min-width: map-get($grid-breakpoints, xl)) {
            margin-right: 135px;
        }
    }
    #switch-container-tablet {
        margin-left: auto;
        order: 2;
        @media (max-width: map-get($grid-breakpoints, lg)) {
            display: block;
        }
        @media (min-width: map-get($grid-breakpoints, lg)) {
            display: none;
        }
        .hamburger-squeeze-custom {
            display: flex;
            padding: 3px;
            margin-left: 30px;
            margin-right: 49px;
            border: 1px solid transparent;
            outline: none;
            @media (max-width: map-get($grid-breakpoints, sm)) {
                margin-left: 15px;
                margin-right: 42px;
            }
            &:focus,
            &:focus-visible {
                outline: none;
                border: 1px solid #147582;
                border-radius: 5px;
            }
        }
        snt-shopping-cart {
            margin-left: 0;
            snt-link {
                margin-left: 30px;
                @media (max-width: map-get($grid-breakpoints, sm)) {
                    margin-left: 15px;
                }
            }
        }
    }
    #item-with-line {
        border-right: 1px solid #e5e5e5;
        padding-right: 15px;
        margin-left: 15px;
    }
    .nav-item-right-group snt-link a {
        box-sizing: border-box;
        padding: 1px 3px 1px 3px !important;
        border-radius: 5px;
        outline: none !important;
        border: 1px solid transparent;
        border-bottom: 1px solid transparent !important;
        &:focus {
            color: #323232;
            border-color: #147582;
            border-bottom-color: #147582 !important;
        }
        &:hover {
            color: #147582;
            text-decoration: underline;
            text-decoration-thickness: 3px;
            text-decoration-color: #147582;
        }
    }
    .dropdown-slab {
        position: absolute;
        left: 0;
        top: 38px;
        padding-top: 35px;
        height: 255px;
        width: 100%;
        display: none;
        margin-left: 20px;
        // z-index: 999;
    }
    .dropdown-slab:hover {
        display: block;
        & snt-navbar {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
    }
    .dropdown-container {
        position: absolute;
        height: auto !important;
        width: 715px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        cursor: pointer;
        left: -10px; // for text aligned, but box left sticking out
    }
    .tablet-column {
        width: 50%;
        @media (max-width: map-get($grid-breakpoints, sm)) {
            display: none;
        }
    }
    .mobile-column {
        width: 100%;
        display: none;
        @media (max-width: map-get($grid-breakpoints, sm)) {
            display: block;
        }
    }
    .dropdown-item-container {
        padding: 10px;
        border-radius: 10px;
        border: 1px solid transparent;
        max-height: 60px;
        snt-link a {
            @media (max-width: map-get($grid-breakpoints, sm)) {
                font-family: "Averta-Regular";
            }
            &:hover {
                text-decoration: underline;
                // text-decoration-color: #147582 !important;
                // text-decoration-thickness: 3px !important;
                text-underline-offset: 2px;
                // color: #323232;
            }
        }
        &:hover {
            background-color: #d9f0f4;
            & snt-link a {
                text-decoration: underline;
                text-underline-offset: 2px;
            }
        }
        &:active {
            background-color: #f2f2f2;
            border-color: #147582;
        }
        &:focus,
        &:focus-visible {
            outline: none !important;
            border-color: #147582;
        }
    }
    .dropdown-maintext {
        @media (min-width: map-get($grid-breakpoints, sm)) {
            font-size: 16px;
            line-height: 21px;
        }
    }
    .dropdown-subtext {
        font-size: 12px;
        font-family: "Averta-Regular", Arial, Helvetica, sans-serif;
        line-height: 18px;
        color: #323232;
        @media (max-width: map-get($grid-breakpoints, sm)) {
            display: none;
        }
    }
    .show {
        display: block !important;
    }
    .hide {
        display: none !important;
    }
    .new-tag {
        margin-left: 5px;
        font-size: 12px;
        border-radius: 2px;
        background-color: #147582;
        color: white;
        padding: 0 3px 0 3px;
        font-size: 12px;
        line-height: 15px;
    }

    snt-nav snt-link a {
        .menu-nav-text {
            display: flex;
            border-bottom: 3px solid transparent;
        }
    }
    snt-nav snt-link a.snt-link-hover-effect {
        color: #147582;
        .menu-nav-text {
            border-color: #147582;
        }
    }

    .navbar {
        align-items: flex-start;
    }
    snt-search-bar .search-pane {
        top: 64px;
        border: none;
        snt-action-button button {
            color: #323232;
        }
    }
    snt-navbar-brand {
        box-sizing: border-box;
        img:focus,
         :focus-visible {
            outline-color: #147582;
        }
    }
    snt-nav #main-nav {
        margin: 0;
    }
    #search-nav-item {
        margin-left: 0;
        button {
            border: 1px solid transparent;
            background: transparent;
            outline: none;
            &:focus {
                border-radius: 5px;
                border-color: #147582;
            }
        }
    }
    #tablet-items-container {
        top: 64px;
        width: 100%;
        padding-left: 37px;
        padding-right: 37px;
        box-sizing: border-box;
        overflow-y: scroll;
        /* Internet Explorer 10+ */
        -ms-overflow-style: none;
        /* Firefox */
        scrollbar-width: none;
        height: 0;
        opacity: 0;
        transition: all 0.5s ease;

        @media (max-width: map-get($grid-breakpoints, sm)) {
            padding-right: 14px;
            font-size: 18px;
            line-height: 20px;
        }

        @media (min-width: map-get($grid-breakpoints, lg)) {
            display: none;
        }
    }
    #tablet-items-container::-webkit-scrollbar {
        display: none;
        /* Safari and Chrome */
    }
    #tablet-items-container.show {
        opacity: 1;
        @media (min-width: map-get($grid-breakpoints, lg)) {
            display: none !important;
        }
        @media (max-width: map-get($grid-breakpoints, lg)) {
            overscroll-behavior: contain;
            height: 95vh;
        }
        @media (max-width: map-get($grid-breakpoints, sm)) {
            height: calc(var(--vh, 1vh) * 95);
        }
    }
    #tablet-items-container.show > div {
        opacity: 1;
    }
    .tablet-item-row {
        font-family: Averta-ExtraBold;
        min-height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-right: 20px;
        padding-left: 6px;
        outline: none;
        border: 1px solid transparent;
        box-sizing: border-box;
        color: #323232;
        cursor: pointer;
        @media (max-width: map-get($grid-breakpoints, sm)) {
            padding-right: 14px;
            font-size: 14px;
            line-height: 20px;
        }
        div:first-of-type {
            display: flex;
            align-items: center;
            width: 100%;
        }
        &.tablet-border-bottom {
            border-bottom: 1px solid #f8f8f8;
        }
        &:focus,
        &:focus-visible {
            border-radius: 5px;
            border-color: #147582;
        }
        &:hover {
            color: #147582;
            text-decoration: underline;
            text-underline-offset: 3px;
        }
        &.tablet-tab-show {
            .chevron {
                transform: rotate(0);
                transform: translate(0, -6px);
                &:before {
                    transform: rotate(-45deg);
                }
                &:after {
                    transform: rotate(45deg);
                }
            }
        }
    }
    .tablet-tab-items-container {
        width: 100%;
        flex-direction: row;
        border-bottom: 1px solid #f8f8f8;
        transition: max-height 0.4s ease;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
    }
    .tablet-tab-items-container.tablet-tab-items-show {
        max-height: 800px;
    }
    .tablet-tab-items-show {
        display: flex;
        visibility: visible;
        transition: 0.4s ease;
        opacity: 1;
    }
    .chevron {
        width: 13px;
        height: 13px;
        margin-left: auto;
        transition: 0.4s ease;
        transform: rotate(0);
        left: 0;
        &:before,
        &:after {
            position: absolute;
            content: '';
            transition: 0.4s ease;
            background-color: transparent;
            width: 3px;
            height: 10px;
            display: inline-block;
            border-bottom: 12px solid $color-primary-grey;
            top: 0;
            left: 0;
            transform: rotate(-135deg);
        }
        &:after {
            transform: rotate(135deg);
        }
    }
    .tablet-switch-container {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f8f8f8;
    }
    #tablet-quote-container {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        padding-bottom: 140px;
        button.get-a-quote-m-header {
            width: 150px;
            height: 45px;
            border-radius: 45px;
            text-align: center;
            vertical-align: middle;
            background-color: #6ebac5;
            color: #323232;
        }
    }
    #tablet-top-quote-wrapper {
        display: none;
    }
    #tablet-search-container {
        #tablet-search-bar {
            display: none;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            position: fixed;
            height: 100%;
            width: 100%;
            z-index: -1;
            background-color: white;
            overflow: hidden;
            &[active] {
                display: block;
            }
        }
        .search-pane {
            top: 0;
            border: 1px solid $color-grey-06;
        }
    }
    #tablet-top-quote-wrapper button.get-a-quote-header {
        @media (max-width: map-get($grid-breakpoints, sm)) {
            width: auto !important;
            height: 33px !important;
            padding: 5px 10px 5px 10px !important;
            margin-right: 0;
            span:first-of-type {
                display: none;
            }
            span:nth-of-type(2) {
                display: block !important;
                line-height: 23px;
                font-size: 14px;
            }
        }
    }
    #nav-close-chevron {
        margin-left: 0;
    }
    #nav-close-chevron::before {
        border-width: 0.2em 0.2em 0 0;
        height: 1.25em;
        top: 2px;
        width: 1.25em;
        border-radius: 3px;
    }
    #tablet-items-container {
        .tablet-switch-container {
            padding: 13px 0;
            & snt-nav-item {
                margin: 0 30px 0 0;
            }
        }
    }
    header.orange {
        snt-button {
            button {
                color:#323232 !important;
                background:linear-gradient(99deg, #FFB259 14.82%, #FFCB32 91.01%);
                box-shadow: none !important;
                &:hover {
                    color:#323232 !important;
                    background:linear-gradient(99deg, #FFCB32 10.71%, #FF930D 85.51%);
                    box-shadow: none !important;
                }
                &:focus {
                    color:#323232 !important;
                    background:linear-gradient(99deg, #FFB259 14.82%, #FFCB32 91.01%);
                    box-shadow: none !important;
                }
                &:active {
                    color:#323232 !important;
                    background:linear-gradient(99deg, #FFCB32 10.71%, #FF930D 85.51%);
                    box-shadow: none !important;
                }
            }
        }
    }
}